export const ObtenerClasificaciones = "ObtenerClasificaciones";
export const ObtenerClasificacionPorCabecera =
  "ObtenerClasificacionPorCabecera";
export const Cargando = "CLASIFICACION_CARGANDO";
export const Error = "CLASIFICACION_ERROR";
